module.exports = __webpack_public_path__ + "static/media/autumn.0bdb55e1.jpg";